module.exports = __webpack_public_path__ + "static/img/23@2x.a7def3b6.png";